export default {
  'roles.name': 'Quản lý vai trò',
  'roles.roleName': 'Tên vai trò',
  'roles.rolePermissions': 'Quyền',
  'roles.permissionCodes': 'Quyền',
  'roles.createdAt': 'Ngày tạo',
  'roles.action': 'Thao tác',
  'Per.Users.Create': 'Thêm user',
  'Per.Users.Delete': 'Xoá user',
  'Per.Users.Edit': 'Sửa user',
  'Per.Users.Export': 'Xuất user',
  'Per.Users.View': 'Xem user',
  'roles.create': 'Tạo vai trò',
  'roles.information': 'Thông tin vai trò',
  'roles.update': 'Chỉnh sửa vai trò',
  'Mes.Users.Role.UpdateSuccessfully': 'Cập nhật vai trò thành công',
  'Mes.Roles.Add.Successfully': 'Thêm vai trò thành công',

  'roles.createdBy': 'Tạo bởi',
  'roles.createDateTime': 'Ngày tạo',
  'roles.internalComment': 'Ghi chú',
  'roles.isActive': 'Trạng thái hoạt động',
  'roles.delete': 'Xoá vai trò',
  'roles.content.delete': 'Bạn có chắc chắn muốn xóa vai trò này không?',
  'roles.add.name': 'Thêm mới vai trò',
  'roles.info.name': 'Thông tin vai trò',
  'roles.edit.name': 'Cập nhật vai trò',

  //role
  'role.RoleModule': 'Vai trò',
  'permission.RoleModule.create': 'Thêm vai trò',
  'permission.RoleModule.delete': 'Xóa vai trò',
  'permission.RoleModule.update': 'Sửa vai trò',
  'permission.RoleModule.view': 'Xem Vai trò',

  //user
  'role.UsersModule': 'Người dùng',
  'permission.UsersModule.create': 'Thêm người dùng',
  'permission.UsersModule.delete': 'Xóa người dùng',
  'permission.UsersModule.update': 'Sửa người dùng',
  'permission.UsersModule.view': 'Xem người dùng',

  //device
  'role.DeviceModule': 'Thiết bị',
  'permission.DeviceModule.create': 'Thêm thiết bị',
  'permission.DeviceModule.delete': 'Xóa thiết bị',
  'permission.DeviceModule.update': 'Sửa thiết bị',
  'permission.DeviceModule.view': 'Xem thiết bị',

  //customer
  'role.CustomerModule': 'Khách hàng',
  'permission.CustomerModule.create': 'Thêm khách hàng',
  'permission.CustomerModule.logs': 'Nhật ký checking',
  'permission.CustomerModule.delete': 'Xóa khách hàng',
  'permission.CustomerModule.update': 'Sửa khách hàng',
  'permission.CustomerModule.view': 'Xem khách hàng',
  'permission.CustomerModule.email': 'Gửi email xác nhận vé',

  //transaction
  'role.TransactionsModule': 'Giao dịch',
  'permission.TransactionsModule.create': 'Thêm giao dịch',
  'permission.TransactionsModule.delete': 'Xóa giao dịch',
  'permission.TransactionsModule.update': 'Sửa giao dịch',
  'permission.TransactionsModule.view': 'Xem giao dịch',
  'permission.TransactionsModule.commit': 'Kết toán',
  'permission.TransactionsModule.refund': 'Hoàn trả',

  //product
  'role.ProductsModule': 'Sản phẩm',
  'permission.ProductsModule.create': 'Thêm sản phẩm',
  'permission.ProductsModule.delete': 'Xóa sản phẩm',
  'permission.ProductsModule.update': 'Sửa sản phẩm',
  'permission.ProductsModule.view': 'Xem sản phẩm',

  //menu
  'role.MenuModule': 'Thực đơn',
  'permission.MenuModule.create': 'Thêm thực đơn',
  'permission.MenuModule.delete': 'Xóa thực đơn',
  'permission.MenuModule.update': 'Sửa thực đơn',
  'permission.MenuModule.view': 'Xem thực đơn',

  //brand
  'role.BrandsModule': 'Nhãn hiệu',
  'permission.BrandsModule.create': 'Thêm nhãn hiệu',
  'permission.BrandsModule.delete': 'Xóa nhãn hiệu',
  'permission.BrandsModule.update': 'Sửa nhãn hiệu',
  'permission.BrandsModule.view': 'Xem nhẫn hiệu',

  //ticket
  'role.TicketsModule': 'Vé',
  'permission.TicketsModule.create': 'Thêm vé',
  'permission.TicketsModule.delete': 'Xóa vé',
  'permission.TicketsModule.update': 'Sửa vé',
  'permission.TicketsModule.view': 'Xem vé',

  'role.TProductModule': 'Sản phẩm',
  'permission.TProductModule.create': 'Thêm sản phẩm',
  'permission.TProductModule.delete': 'Xóa sản phẩm',
  'permission.TProductModule.update': 'Sửa sản phẩm',
  'permission.TProductModule.view': 'Xem sản phẩm',

  'role.DeviceLogModule': 'Thiết bị',
  'permission.DeviceLogModule.view': 'Xem thiết bị',
  'permission.DeviceLogModule.delete': 'Xóa thiết bị',
  'permission.DeviceLogModule.update': 'Sửa thiết bị',
  'permission.DeviceLogModule.create': 'Thêm thiết bị',
  'role.CustomerTicketModule': 'Vé',
  'permission.CustomerTicketModule.view': 'Xem vé',
  'permission.CustomerTicketModule.delete': 'Xóa vé',
  'permission.CustomerTicketModule.update': 'Sửa vé',
  'permission.CustomerTicketModule.create': 'Thêm vé',

  'permission.TransactionsModule.topup': 'Nạp tiền',
  'permission.TransactionsModule.sale': 'Bán hàng',
};
